import React from 'react'
import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import { PHCont } from './styled'
import { StdForm } from 'components'
import { ProcessRow } from './ProcessRow'

const DPProcessHistory = (props) => {
  const { dpDetail } = props

  return (
    <PHCont>
      <StdForm title='Comment' style={{ flex: 1, width: '100%' }}>
        {
          dpDetail && dpDetail.downPaymentComments.map((item, i) => {
            let files = dpDetail.downPaymentAttachments.filter(x=>x.commentId===item.id)
            // let file = files.filter(a =>a.documentType === 'DP02')
            return (<ProcessRow data={item} files={files}  />)
          })
        }
      </StdForm>
    </PHCont>
  )
}

const mapStateToProps = (state) => ({
  dpDetail: state.downPayment.downPaymentDetail.data,
})
const mapDispatchToProps = {

}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  connect((state, props) => ({
    history: props.history
  })),
  lifecycle({
    componentDidMount() {

    },
    componentWillReceiveProps(nextProp) {

    }
  })
)

export default enhance(DPProcessHistory)
